import DracoWorker from 'worker-loader!./draco.worker'

export function createDracoWorker(): Worker {
  return new DracoWorker()
}
